// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { makeModulationSchemeLabel } from 'redux/helpers'

const scrubSingleModulationScheme = m => ({
  modulationScheme: makeModulationSchemeLabel(m),
  modulationSchemeId: m.modulationSchemeId,
  modulationSchemeTypeId: m.modulationSchemeType.modulationSchemeTypeId,
})

export default scrubSingleModulationScheme
